var configData = {
  apiV2Config: {
    headers: {
      Accept: "application/vnd.foaps.v2"
    }
  }
};
export default (function (context, inject) {
  inject("configData", configData);
});